import * as React from 'react';
import * as Site from '../../shared/Site';
import * as actions from './actions/PlanEditorOrdersActions';
import notify from '../../shared/feedback/notifications';
import * as Features from '../../shared/Features';
import { connect } from 'react-redux';
import { Translate } from '../../shared/LanguageService';
import { IPlanOrder } from './Entities';
import { Table, Button } from 'react-bootstrap';
import ConfirmationModal from '../../components/common/ConfirmationModal';
import PlanEditorOrderModal from './edit/PlanEditorOrderModal';
import AutoUpdateListTrigger from '../../shared/AutoUpdateListTrigger';
import DateTimeView from '../../features/localDate/DateTimeView';

interface PlanEditorOrdersProps {
    planOrders: IPlanOrder[];
    user: any;
    actions: IActions;
}

interface IState {
    showGrabConfirmation: boolean;
    showEditModal: boolean;
    grabPlanOrderId?: number;
    editPlanOrderId?: number;
    isLoading: boolean;
}

interface IPartialList {
    planOrders: IPlanOrder[];
    user: any;
    header: JSX.Element;
    showGrabModal: (id: number) => void;
    isTheReturnedList: boolean;
    edit: (orderId: number) => void;
}

const PartialListCell = (props: {
    planOrder: IPlanOrder;
    edit: (orderId: number) => void;
    children?: any;
    user: any;
}) => {
    function onClick() {
        if (
            props.planOrder.planEditorId ||
            Features.hasFeature(Features.ViewUngrabbedPlanOrder, props.user)
        ) {
            props.edit(props.planOrder.id);
        }
    }

    return (
        <td
            onClick={onClick}
            className={
                props.planOrder.planEditorId ||
                Features.hasFeature(Features.ViewUngrabbedPlanOrder, props.user)
                    ? 'clickable'
                    : ''
            }
        >
            {props.children}
        </td>
    );
};

const PartialList = (props: IPartialList) => {
    function getOrderRowCssClass(order: IPlanOrder): string {
        return Site.getOrderCssClass(order.site) + (order.isExpress === true ? ' express' : '');
    }

    return (
        <Table responsive className="order-table" hover>
            <caption>{props.header}</caption>
            <thead>
                <tr>
                    <th width="90">{Translate('planeditor/orders/list/header/orderid')}</th>
                    <th>{Translate('planeditor/orders/list/header/customer')}</th>
                    <th>{Translate('planeditor/orders/list/header/address')}</th>
                    <th width="120">{Translate('planeditor/orders/list/header/product')}</th>
                    <th width="120">{Translate('planeditor/orders/list/header/deadline')}</th>
                    <th width="100">{Translate('planeditor/orders/list/header/status')}</th>
                    {Features.hasFeature(Features.ViewPlanEditorColumn, props.user) && (
                        <th width="140">
                            {Translate('planeditor/orders/list/header/plan-editor')}
                        </th>
                    )}
                    {!Features.hasFeature(Features.ViewPlanEditorColumn, props.user) && (
                        <th width="110"></th>
                    )}
                    {props.isTheReturnedList && props.planOrders.length > 0 && (
                        <th width="110">
                            {Translate('planeditor/orders/list/header/previous-plan-editor')}
                        </th>
                    )}
                    {!(props.isTheReturnedList && props.planOrders.length > 0) && (
                        <th width="110"></th>
                    )}
                    {props.isTheReturnedList && (
                        <th width="140">
                            {Translate('planeditor/orders/list/header/returned-by')}
                        </th>
                    )}
                </tr>
            </thead>
            <tbody>
                {props.planOrders.map((x) => (
                    <tr key={x.id} className={getOrderRowCssClass(x)}>
                        <PartialListCell planOrder={x} edit={props.edit} user={props.user}>
                            {x.orderCollectionNumber + ':' + x.orderNumber}
                        </PartialListCell>
                        <PartialListCell planOrder={x} edit={props.edit} user={props.user}>
                            {x.customer}
                        </PartialListCell>
                        <PartialListCell planOrder={x} edit={props.edit} user={props.user}>
                            {x.address}
                        </PartialListCell>
                        <PartialListCell planOrder={x} edit={props.edit} user={props.user}>
                            {x.firstPlanSketchupProductName}
                        </PartialListCell>
                        <PartialListCell planOrder={x} edit={props.edit} user={props.user}>
                            <DateTimeView dateTime={x.deadline} format="L LT" />
                        </PartialListCell>
                        <PartialListCell planOrder={x} edit={props.edit} user={props.user}>
                            {Translate(x.status)}
                        </PartialListCell>
                        {Features.hasFeature(Features.ViewPlanEditorColumn, props.user) &&
                            x.planEditorId && (
                                <PartialListCell planOrder={x} edit={props.edit} user={props.user}>
                                    {x.planEditor}
                                </PartialListCell>
                            )}
                        {Features.hasFeature(Features.ViewPlanEditorColumn, props.user) &&
                            x.planEditorId === null && (
                                <td>
                                    <Button onClick={() => props.showGrabModal(x.id)}>
                                        {Translate('planeditor/orders/list/grab-button')}
                                    </Button>
                                </td>
                            )}
                        {!Features.hasFeature(Features.ViewPlanEditorColumn, props.user) &&
                            x.planEditorId === null && (
                                <td>
                                    <Button onClick={() => props.showGrabModal(x.id)}>
                                        {Translate('planeditor/orders/list/grab-button')}
                                    </Button>
                                </td>
                            )}
                        {!Features.hasFeature(Features.ViewPlanEditorColumn, props.user) &&
                            x.planEditorId !== null && <td></td>}
                        {props.isTheReturnedList && (
                            <PartialListCell planOrder={x} edit={props.edit} user={props.user}>
                                {x.previousPlanEditor}
                            </PartialListCell>
                        )}
                        {!props.isTheReturnedList && <td></td>}
                        {props.isTheReturnedList && (
                            <td>
                                {x.returnedByCustomer
                                    ? Translate('planeditor/orders/list/returned-by-customer')
                                    : 'SE360'}
                            </td>
                        )}
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

class PlanEditorOrders extends React.Component<PlanEditorOrdersProps, IState> {
    private _updateListTrigger: AutoUpdateListTrigger;

    constructor(props: PlanEditorOrdersProps, context: any) {
        super(props, context);

        this.state = {
            showGrabConfirmation: false,
            showEditModal: false,
            isLoading: false
        };

        this.getPlanOrders = this.getPlanOrders.bind(this);
        this.grab = this.grab.bind(this);
        this.edit = this.edit.bind(this);
        this.closeGrabModal = this.closeGrabModal.bind(this);
        this.closeEditModal = this.closeEditModal.bind(this);
        this.showGrabModal = this.showGrabModal.bind(this);
        this.isNew = this.isNew.bind(this);
        this.isCurrent = this.isCurrent.bind(this);

        this._updateListTrigger = new AutoUpdateListTrigger(this.getPlanOrders);
    }

    componentDidMount(): void {
        this.getPlanOrders();
        this._updateListTrigger.subscribe();
    }

    componentWillUnmount() {
        this._updateListTrigger.unsubscribe();
        this.props.actions.resetList();
    }

    getPlanOrders() {
        if (!this.state.isLoading) {
            this.setState({ isLoading: true } as IState);
            this.props.actions
                .getPlanOrders()
                .then(() => {
                    this.setState({ isLoading: false } as IState);
                })
                .catch((error: any) => {
                    this.setState({ isLoading: false } as IState);
                });
        }
    }

    isReturned(planOrder: IPlanOrder): boolean {
        return planOrder.isReturned;
    }

    isNew(planOrder: IPlanOrder): boolean {
        return !this.isReturned(planOrder) && planOrder.planEditorId === null;
    }

    isCurrent(planOrder: IPlanOrder): boolean {
        return !this.isReturned(planOrder) && !this.isNew(planOrder);
    }

    orderSort(current: IPlanOrder, next: IPlanOrder): number {
        if (current.deadline.localDateTime > next.deadline.localDateTime) {
            return 1;
        } else if (current.deadline.localDateTime < next.deadline.localDateTime) {
            return -1;
        }

        return 0;
    }

    render() {
        const returnedOrders: IPlanOrder[] = this.props.planOrders
            .filter(this.isReturned)
            .sort(this.orderSort);
        const currentOrders: IPlanOrder[] = this.props.planOrders
            .filter(this.isCurrent)
            .sort(this.orderSort);
        const newOrders: IPlanOrder[] = this.props.planOrders
            .filter(this.isNew)
            .sort(this.orderSort);

        return (
            <div>
                <h1>
                    {Translate('planeditor/orders/list/title')}{' '}
                    {!this.state.isLoading && (
                        <span className="number-of-orders">({this.props.planOrders.length})</span>
                    )}
                </h1>
                <PartialList
                    header={
                        <h2>
                            {Translate('planeditor/orders/list/returned/title')}{' '}
                            {!this.state.isLoading && (
                                <span className="number-of-orders">({returnedOrders.length})</span>
                            )}
                        </h2>
                    }
                    planOrders={returnedOrders}
                    user={this.props.user}
                    showGrabModal={this.showGrabModal}
                    edit={this.edit}
                    isTheReturnedList={true}
                />

                <PartialList
                    header={
                        <h2>
                            {Translate('planeditor/orders/list/current/title')}{' '}
                            {!this.state.isLoading && (
                                <span className="number-of-orders">({currentOrders.length})</span>
                            )}
                        </h2>
                    }
                    planOrders={currentOrders}
                    user={this.props.user}
                    showGrabModal={this.showGrabModal}
                    edit={this.edit}
                    isTheReturnedList={false}
                />

                <PartialList
                    header={
                        <h2>
                            {Translate('planeditor/orders/list/new/title')}{' '}
                            {!this.state.isLoading && (
                                <span className="number-of-orders">({newOrders.length})</span>
                            )}
                        </h2>
                    }
                    planOrders={newOrders}
                    user={this.props.user}
                    showGrabModal={this.showGrabModal}
                    edit={this.edit}
                    isTheReturnedList={false}
                />

                {this.state.showGrabConfirmation && (
                    <ConfirmationModal
                        title={Translate('planeditor/orders/list/grab/modal/title')}
                        text={Translate('planeditor/orders/list/grab/modal/text')}
                        doButtonLabel={Translate('planeditor/orders/list/grab/modal/do-button')}
                        cancelButtonLabel={Translate(
                            'planeditor/orders/list/grab/modal/cancel-button'
                        )}
                        doButtonStyle="danger"
                        do={this.grab}
                        closeModal={this.closeGrabModal}
                    />
                )}

                {this.state.showEditModal && this.state.editPlanOrderId && (
                    <PlanEditorOrderModal
                        planOrderId={this.state.editPlanOrderId}
                        onClose={this.closeEditModal}
                    />
                )}
            </div>
        );
    }

    grab(): void {
        this.props.actions.grabPlanOrder(this.state.grabPlanOrderId).catch(() => {
            notify.failure(Translate('planeditor/orders/list/grab-error'));
        });

        this.closeGrabModal();
    }

    showGrabModal(planOrderId: number): void {
        this.setState({
            showGrabConfirmation: true,
            grabPlanOrderId: planOrderId
        } as IState);
    }

    closeGrabModal(): void {
        this.setState({
            showGrabConfirmation: false,
            grabPlanOrderId: null
        } as IState);
    }

    edit(planOrderId: number): void {
        this.setState({
            showEditModal: true,
            editPlanOrderId: planOrderId
        } as IState);
    }

    closeEditModal(): void {
        this.setState({
            showEditModal: false,
            editPlanOrderId: null
        } as IState);
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        planOrders: state.ordersList.list.sort((a: IPlanOrder, b: IPlanOrder) => {
            return b.planEditorId - a.planEditorId;
        }),
        user: state.user
    };
}

function mapDispatchToProps(dispatch: any): { actions: IActions } {
    return {
        actions: {
            getPlanOrders: () => dispatch(actions.getPlanOrders()),
            grabPlanOrder: (planOrderId: number) => dispatch(actions.grabPlanOrder(planOrderId)),
            resetList: () => dispatch(actions.resetList())
        }
    };
}

interface IActions {
    getPlanOrders: () => Promise<any>;
    grabPlanOrder: (planOrderId: number) => Promise<any>;
    resetList: () => Promise<any>;
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanEditorOrders);
